<template>
  <div class="manual-runes">
    <ManualRune
      v-for="(rune, index) in runes"
      :key="rune.type"
      :rune="rune"
      :intersected="intersectedRunes[index]"
      v-bind="getDirection(index)"
      @intersect="onIntersect(index)"
    />
  </div>
</template>

<script>
import ManualRune from "./ManualRune";
import debounce from "lodash/debounce";

function timeout(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export default {
  name: "ManualRunes",
  components: {
    ManualRune
  },
  data: () => ({
    intersectedRunes: {},
    queue: [],
    queueInProgress: false,
    runes: [
      {
        name: "Arcane",
        type: "arcane",
        img: require("@/assets/img/runes/rune-arcane.png"),
        descriptions: [
          "Coldown Reduction",
          "Spell Amplification",
          "Mana cost Reduction"
        ]
      },
      {
        name: "Haste",
        type: "haste",
        img: require("@/assets/img/runes/rune-haste.png"),
        descriptions: [
          "Bonus attack speed",
          "Bonus Movespeed",
          "Min. movespeed"
        ]
      },
      {
        name: "Bounty",
        type: "bounty",
        img: require("@/assets/img/runes/rune-bounty.png"),
        descriptions: ["Base Gold", "Gold increase p/m", "XP + increase p/m"]
      },
      {
        name: "Illusion",
        type: "illusions",
        img: require("@/assets/img/runes/rune-illusions.png"),
        descriptions: ["Illusions created", "Damage dealt"]
      },
      {
        name: "Double damage",
        type: "double-damage",
        img: require("@/assets/img/runes/rune-dd.png"),
        descriptions: ["Additional Damage"]
      },
      {
        name: "Invisibility",
        type: "invisibility",
        img: require("@/assets/img/runes/rune-invisibility.png"),
        descriptions: ["Bonus Damage", "Bonus Movespeed"]
      },
      {
        name: "Frost",
        type: "frost",
        img: require("@/assets/img/runes/rune-frost.png"),
        descriptions: ["Attack slow", "Movement slow", "Slow duration"]
      },
      {
        name: "Regeneration",
        type: "regeneration",
        img: require("@/assets/img/runes/rune-regeneration.png"),
        descriptions: ["Hits before cancel", "Health p/s", "Mana p/s"]
      }
    ]
  }),
  watch: {
    "queue.length": {
      handler: "debouncedWatcher"
    }
  },
  methods: {
    debouncedWatcher: debounce(function(val) {
      if (val && !this.queueInProgress) {
        this.showRunes();
      }
    }, 150),
    getDirection(index) {
      const dir = index % 2 === 0 ? "left" : "right";
      return { [dir]: !!dir };
    },
    onIntersect(index) {
      this.queue.push(index);
    },
    async showRunes() {
      const { showRunes, showRune, queue } = this;
      if (!queue.length) {
        this.queueInProgress = false;
        return;
      }
      this.queueInProgress = true;
      this.queue.sort((a, b) => a - b);
      await showRune(queue[0]);
      queue.shift();
      showRunes();
    },
    async showRune(index) {
      this.$set(this.intersectedRunes, index, true);
      await timeout(150);
    }
  }
};
</script>

<style lang="scss">
.manual-runes {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 60px;
  background: url("~@/assets/img/manual/bg-flame.png") 50% 0 no-repeat;

  @media (max-width: 1264px) {
    flex-direction: column;
    align-items: center;
  }

  @include breakpoint("sm-and-down") {
    margin-top: 40px;
  }
}
</style>
